import React, { Component } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import { DLTextField, PrimaryButton } from 'appSrc/components/UI';
import LoadingReplace from 'appSrc/components/Shards/Loading/LoadingReplace';
import AllArticlesTable from './Table';
import NewArticleModal from '../../Modals/Article/NewArticleModal';
import { Link } from 'react-router-dom';
import style from './styles/style.module.css';

class AllArticlesView extends Component {
    constructor( props ) {
        super( props );
        this.state = {
            fetching: true,
            newModal: false,
            articles: [],
            searchValue: '',
        };

        this.articleQueryObject = {
            sort: 'title,id',
            search: undefined,
            page: 1,
            limit: 30,
        };
    }
    componentDidMount() {
        this.loadArticles();
    }
    updateSearch = ( e, { value } ) => {
        this.setState( { searchValue: value } );
    }
    onSearchKeyDown = ( e ) => {
        if( e.keyCode == 13 ) {
            e.preventDefault();
            this.articleQueryObject.search = this.state.searchValue || undefined;
            this.articleQueryObject.page = 1;
            this.setState( {
                fetching: true,
                articles: [],
            } );
            this.loadArticles();
        }
    }
    onColumnSort = ( value ) => {
        if( this.articleQueryObject.sort == value ) {
            value = `-${ value }`;
        }
        this.articleQueryObject.sort = value;
        this.articleQueryObject.page = 1;
        this.setState( {
            fetching: true,
            articles: [],
        } );
        this.loadArticles();
    }
    loadArticles = () => {
        return this.props.getArticles( this.articleQueryObject )
        .then( ( articles ) => {
            this.articleQueryObject.page++;
            this.setState( ( prevState ) => {
                prevState.fetching = false;
                prevState.articles = prevState.articles.concat( articles );
                return prevState;
            } );
            return articles;
        } );
    }
    articleUpdated = ( index, article ) => {
        this.setState( ( altState ) => {
            if( article !== null ) {
                altState.articles[ index ] = article;
            } else {
                altState.articles.splice( index, 1 );
            }
            altState.articles = altState.articles.slice( 0 );
            return altState;
        } );
    }

    openNewModal = () => {
        this.setState( { newModal: true } );
    }
    onNewModalClose = () => {
        this.setState( { newModal: false } );
    }
    onNewModalSubmit = ( newArticle ) => {
        this.setState( ( altState ) => {
            altState.articles.unshift( newArticle );
            altState.articles = altState.articles.slice( 0 );
            altState.newModal = false;
            return altState;
        } );
    }

    render() {
        const { fetching, articles, searchValue } = this.state;

        return (
            <section className={ style.page }>
                <div className={ style.head }>
                    <h2>Content</h2>
                    <h3>(Articles, Classes, &amp; How-Tos)</h3>
                    <div className={ style.controls }>
                        <DLTextField className={ style.searchBar }
                        placeholder='Search'
                        value={ searchValue }
                        onChange={ this.updateSearch }
                        onKeyDown={ this.onSearchKeyDown }
                        noError />
                        <PrimaryButton
                        label='+ Create Content'
                        style={ { width: '150px' } }
                        onClick={ this.openNewModal } />
                    </div>
                    <div className={ style.tabs }>
                        <Link to='/admin/content' className={ style.tabOption }
                        data-active={ true }>View All</Link>
                        <Link to='/admin/content/featured' className={ style.tabOption }>Featured Articles</Link>
                    </div>
                </div>
                <div className={ style.body }>
                    <section className={ style.allArticle }>
                        <div className={ style.filters }>
                        </div>
                        { fetching ?
                            <LoadingReplace />
                            :
                            <AllArticlesTable
                            articles={ articles }
                            loadMore={ this.loadArticles }
                            currentSort={ this.articleQueryObject.sort }
                            onColumnSort={ this.onColumnSort }
                            onArticleUpdated={ this.articleUpdated }
                            elementHeight={ 70 } />
                        }
                    </section>
                </div>
                { this.state.newModal &&
                    <NewArticleModal closeModal={ this.onNewModalClose }
                    onSubmit={ this.onNewModalSubmit }/>
                }
            </section>
        );
    }
}

const mapDispatchToProps = () => {
    return {
        getArticles: ( queryObject ) => {
            return dAPI.get( '/admin/content', queryObject );
        },
    };
};

export default connect( null, mapDispatchToProps )( AllArticlesView );
